import React, { FC, ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Roles } from '../../commonType';
import {
  setLoadingStatus,
  setPaymentButtonState,
  // eslint-disable-next-line prettier/prettier
  setPaymentToken,
} from '../../features/offerConfirmation/offerConfirmationSlice';
import { RootState } from '../../redux/rootReducer';
import { OFFER_REVIEW_PATH } from '../../util/strings';
import withLocalization from '../hoc/withLocalization';
import withRoles from '../hoc/withRoles';

const ContactInformationSelector: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const paymentFormValid = useSelector((state: RootState) => state.confirmation.paymentFormValid);
  const flexFormSubmitHandler = useSelector((state: RootState) => state.confirmation.flexFormSubmitHandler);

  const allContactInfoChecked = offerDetails.contactInfoChecked;
  const allBillingInfoChecked = offerDetails.billingInfoChecked;

  const btnEnable =
    props.userRole === Roles.Call_Center_Associate
      ? !allContactInfoChecked
      : !allContactInfoChecked && !allBillingInfoChecked && paymentFormValid;
  const [errMsg, setErrMsg] = useState('');
  const dispatch = useDispatch();

  const handleClick = (event) => {
    if (props.userRole === Roles.Field_Associate) {
      if (flexFormSubmitHandler) {
        dispatch(setLoadingStatus(true));
        flexFormSubmitHandler((err, token) => {
          dispatch(setLoadingStatus(false));
          if (!err) {
            dispatch(setPaymentToken(token));
            props.history.push(OFFER_REVIEW_PATH);
          } else {
            setErrMsg('Error generating token');
            console.log(err);
            dispatch(setPaymentButtonState(true));
          }
        });
      }
    } else {
      props.history.push(OFFER_REVIEW_PATH);
    }
  };

  return (
    <>
      <div className="">
        <div className="invalid-feedback-onchange">{errMsg}</div>
        {props.userRole === Roles.Field_Associate ? (
          allContactInfoChecked || allBillingInfoChecked || !paymentFormValid ? (
            <div className="invalid-feedback-onchange-btn">
              {localize('preview-sales-engine.static-content.copy.Labels.labels#mandatory-field-statement')}
            </div>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
        <button onClick={handleClick} className="btn nextButton" disabled={!btnEnable}>
          {localize('preview-sales-engine.static-content.copy.contact-information-page.next-button')}
        </button>
        <div className="invalid-feedback-onchange-btn">
          {localize('preview-sales-engine.static-content.copy.contact-information-page.mandatory-field-indicator')}
        </div>
      </div>
    </>
  );
};

export default withRouter(withLocalization(withRoles(ContactInformationSelector)));
